import { Injectable } from '@angular/core';
import { CoolLocalStorage } from '@angular-cool/storage';
import { bcSessionKeys } from 'common/common/constants/session-keys';
import { WorkItemTypes } from '../../../common/workitems/constants/workitem-types';

@Injectable()
export class ClosingConfirmationService {

  constructor(private _localStorage: CoolLocalStorage) {
  }

  public setClosingConfirmation(workItemType, setting): void {
    switch (workItemType) {
      case WorkItemTypes.GENESYS_CHAT:
      case WorkItemTypes.CHAT:
        this._localStorage.setObject(bcSessionKeys.storage.confirmClosingDisabled + bcSessionKeys.storage.chatPostFix, setting);
        break;
      case WorkItemTypes.SMS:
      case WorkItemTypes.FACEBOOK:
      case WorkItemTypes.ASYNC_MESSAGE:
        this._localStorage.setObject(bcSessionKeys.storage.confirmClosingDisabled + bcSessionKeys.storage.textChatPostFix, setting);
        break;
      case WorkItemTypes.EMAIL:
      case WorkItemTypes.GENESYS_EMAIL:
        this._localStorage.setObject(bcSessionKeys.storage.confirmClosingDisabled + bcSessionKeys.storage.emailPostFix, setting);
        break;
      default:
        throw new Error('Unsupported workItemType for saving confirm closing setting');
    }
  }

  public getClosingConfirmationSetting(workItemType) {
    switch (workItemType) {
      case WorkItemTypes.GENESYS_CHAT:
      case WorkItemTypes.CHAT:
        return this._localStorage.tryGetObject(bcSessionKeys.storage.confirmClosingDisabled + bcSessionKeys.storage.chatPostFix);
      case WorkItemTypes.SMS:
      case WorkItemTypes.FACEBOOK:
      case WorkItemTypes.ASYNC_MESSAGE:
        return this._localStorage.tryGetObject(bcSessionKeys.storage.confirmClosingDisabled + bcSessionKeys.storage.textChatPostFix);
      case WorkItemTypes.EMAIL:
      case WorkItemTypes.GENESYS_EMAIL:
        return this._localStorage.tryGetObject(bcSessionKeys.storage.confirmClosingDisabled + bcSessionKeys.storage.emailPostFix);
      default:
        throw new Error('Unsupported workItemType for getting confirm closing setting');
    }
  }
}
